import { LeftBar } from "../components";
import { Outlet, useParams, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { createGameStorage } from "../hooks/useGameStorage";
import { useEffect, useState, useRef, useMemo } from "react";
import * as amplitude from '@amplitude/analytics-browser';
import { PaddleInit } from "./Paddle";
import { useDispatch, useSelector } from "react-redux";
import { checkLoginThunk } from "../redux/features/userSlice";
import Navbar from "../components/global/Navbar/Navbar";
import * as Sentry from "@sentry/react";
import { Gift } from "../components/global/Navbar/Gift";
import { Strike } from "../components/global/Navbar/Strike";
import { Settings } from "../components/global/Navbar/Settings";
import { Subscription } from "../components/global/Subscription/Subscription";
import { Avatar } from "../components/global/Profile/Avatar";
import {
    updateGift,
    updateSelectedProfile,
    addGift
} from '../redux/features/userSlice';

import {
    fetchDailyScoreThunk
} from '../redux/features/scoresSlice';
import { IconGift, IconFire, IconTop } from "../components/elements/Icon";

export default function Layout() {
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [openScore, setOpenScore] = useState(false);
    const [strike, setStrike] = useState(false);
    const [gift, setGift] = useState(false);
    const [openAvatar, setOpenAvatar] = useState(false);
    const [avatar, setAvatar] = useState([]);
    const [rightAnswers, setRightAnswers] = useState(0);
    const [backgroundMusic, setBackgroundMusic] = useState(JSON.parse(localStorage.getItem("backgroundMusic")));
    const [sound, setSound] = useState(JSON.parse(localStorage.getItem("sound")));
    const [hint, setHint] = useState(true);
    const [language, setLanguage] = useState(false);

    const selectedProfile = useSelector(
        state => state.user.selectedProfile
    );

    const progressReportEnabled = useSelector(
        state => state.user.user?.progressReportEnabled
    );
    let dailyScore = useSelector(state => state.scores.dailyScore);
    if (!selectedProfile) dailyScore = normalizeDailyScore(JSON.parse(localStorage.getItem("scoreStorage")) || [])

    const questionHistoryEnabled = useSelector(
        state => state.user.user?.questionHistoryEnabled
    );
    let { name, gameName } = useParams();
    const [targetPos, setTargetPos] = useState(null);
    const giftRef = useRef(null);

    const giftRefMobile = useRef(null);
    const containerRef = useRef(null);
    const navigate = useNavigate();

    const leaderboardPath = (() => {
        if (location.pathname.startsWith("/games")) {
            if (name && gameName) {
                return `/games/${name}/${gameName}/leaderboard`;
            }

            if (name) {
                return `/games/${name}/leaderboard`;
            }
        }
        let nameFromStorage = localStorage.getItem("name")

        return `/games/${nameFromStorage}/leaderboard`;
    })();
    const gamePath = `/games/${name}/${gameName || ""}`;

    function normalizeDailyScore(data = []) {
        const today = new Date();

        const minDate = new Date(today);
        minDate.setUTCDate(today.getUTCDate() - 35);

        let normalized = data
            .filter(item =>
                item &&
                item.date &&
                typeof item.score !== 'undefined'
            )

            .map(item => {
                let date = item.date;

                // DD.MM.YYYY -> YYYY-MM-DD
                if (date.includes('.')) {
                    const [d, m, y] = date.split('.');

                    date = `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
                } else {
                    date = date.split('T')[0];
                }

                return {
                    ...item,
                    date,
                };
            })

            .filter(item => {
                const itemDate = new Date(item.date);

                return itemDate >= minDate;
            });

        if (!localStorage.getItem("lastProgress") && normalized.length) {
            normalized = normalized
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .slice(1);
        }

        return normalized;
    }

    const formatDateKey = (date = new Date()) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, "0");
        const d = String(date.getDate()).padStart(2, "0");

        return `${y}-${m}-${d}`;
    };

    const handleGiftClick = () => {
        if (isGiftFlying) return;
        const ref = screenSize.width >= 736 ? giftRef : giftRefMobile
        if (!containerRef.current || !ref.current) return;
        requestAnimationFrame(() => {
            const rect = ref.current.getBoundingClientRect();
            const containerRect = containerRef.current.getBoundingClientRect();

            setTargetPos({
                x: rect.left - containerRect.left + rect.width / 2,
                y: screenSize.width >= 736 ? rect.top - containerRect.top + rect.height / 2 : screenSize.width >= 440 ? rect.top - containerRect.top + rect.height - 35 : rect.top - containerRect.top + rect.height - 30,
            });

            setIsGiftFlying(true);

            setTimeout(() => {
                setShowAnimatedGift(false);
                setTargetPos(null);
                setIsGiftFlying(false);
                handleAnimatedGiftClick();
            }, 2000);
        });

    };

    const toggleRef = useRef(null);
    const [openSubscription, setOpenSubscription] = useState(false);
    const [subscriptionType, setSubscriptionType] = useState("");

    const h = window.innerHeight;
    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });
    const subscription = useSelector(state => state.user.subscription);
    const user = useSelector(state => state.user.user);
    const [leftBarClicked, setLeftBarClicked] = useState(false);
    const [navBarClicked, setNavBarClicked] = useState(false);
    const [isGiftFlying, setIsGiftFlying] = useState(false);
    const [showAnimatedGift, setShowAnimatedGift] = useState(false);
    const [isChanged, setIsChanged] = useState(false);
    useEffect(() => {
        const today = new Date();

        if (selectedProfile) {
            if (!selectedProfile.giftCollectedDate) {
                setShowAnimatedGift(true);
                return;
            }

            const last = new Date(selectedProfile.giftCollectedDate);
            const sameDay =
                today.getDate() === last.getDate() &&
                today.getMonth() === last.getMonth() &&
                today.getFullYear() === last.getFullYear();
            setShowAnimatedGift(!sameDay);
            return;
        }

        const lastCollected = localStorage.getItem("animatedGiftCollectedDate");


        if (!lastCollected) {
            setShowAnimatedGift(true);
            return;
        }

        const last = new Date(lastCollected);

        const sameDay =
            today.getDate() === last.getDate() &&
            today.getMonth() === last.getMonth() &&
            today.getFullYear() === last.getFullYear();
        setShowAnimatedGift(!sameDay);

    }, [selectedProfile]);

    const [giftStartPercent] = useState({
        x: Math.random() < 0.5 ? (screenSize.width > 736 ? 5 : 60) : (screenSize.width > 736 ? 90 : 70),
        y: Math.random() < 0.5 ? (screenSize.width > 736 ? 40 : 90) : (screenSize.width > 736 ? 70 : 90),
    });


    const [days, setDays] = useState(() => {
        if (selectedProfile?.gift) {
            localStorage.setItem("days", selectedProfile.gift);
            return selectedProfile.gift
        }
        const storedDays = localStorage.getItem("days");
        if (storedDays !== null) {
            return Number(storedDays);
        }

        return 0;
    });

    // paddle payment gateway setup
    PaddleInit();
    createGameStorage();

    const handleSubscription = (type, state) => {
        if (!state) {
            setOpenSubscription(!openSubscription);
        }
        setSubscriptionType(type);
    }

    const handleResize = () => {
        setScreenSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    useEffect(() => {
        if (selectedProfile?._id) {
            dispatch(fetchDailyScoreThunk({
                id: selectedProfile._id,
                skip: 0,
                limit: 50
            }));
        }
    }, [selectedProfile]);


    useEffect(() => {
        amplitude.track(`App Start`);
        dispatch(checkLoginThunk()).then(res => localStorage.setItem('user', res.payload.user?._id));
        Sentry.setUser({
            email: user?._id || "",
        })
    }, []);

    useEffect(() => {
        dispatch(checkLoginThunk()).then(res => {
            if (res.payload.login) {
                localStorage.setItem('user', res.payload?.user._id);
                localStorage.setItem('subscription', JSON.stringify(res.payload?.subscription));
            } else {
                localStorage.removeItem('user');
                localStorage.removeItem('subscription');
                localStorage.removeItem('profile');
            }
        });
    }, [dispatch]);

    const handleLeftBarClick = () => {
        setGift(false),
            setStrike(false)
        setLeftBarClicked(!leftBarClicked)
    };
    const handleNavBarClick = () => {
        setNavBarClicked(!navBarClicked)
    };

    const handleAnimatedGiftClick = async () => {
        const today = new Date();

        if (selectedProfile?._id) {
            try {
                await dispatch(
                    addGift({
                        _id: selectedProfile._id,
                        count: 1,
                    })
                ).unwrap();

                dispatch(
                    updateSelectedProfile({
                        ...selectedProfile,
                        gift: selectedProfile.gift + 1,
                        giftCollectedDate: Date.now()
                    })
                );
            } catch (err) {
                console.error(err);
                return;
            }
        } else {
            const newDays = days + 1;
            setDays(newDays);
            localStorage.setItem("days", newDays);

            const storage = localStorage.getItem("dailyGift");
            const gifts = storage ? JSON.parse(storage) : {};

            const todayKey = formatDateKey();

            gifts[todayKey] = (gifts[todayKey] || 0) + 1;

            const sortedKeys = Object.keys(gifts).sort();

            if (sortedKeys.length > 9) {
                const keysToDelete = sortedKeys.slice(0, sortedKeys.length - 9);
                keysToDelete.forEach((key) => {
                    delete gifts[key];
                });
            }

            localStorage.setItem("dailyGift", JSON.stringify(gifts));
        }

        const storage = localStorage.getItem("scoreStorage");
        const scores = storage ? JSON.parse(storage) : [];

        scores.push({
            date: `${today.getDate()}.${today.getMonth() + 1}.${today.getFullYear()}`,
        });

        localStorage.setItem("scoreStorage", JSON.stringify(scores));
        localStorage.setItem("animatedGiftCollectedDate", today.toISOString());

    };

    useEffect(() => {
        localStorage.setItem("days", days);
    }, [days]);


    useEffect(() => {
        if (selectedProfile?.gift != null) {
            setDays(selectedProfile.gift);
        }
    }, [selectedProfile]);

    const getContinuousDays = () => {
        if (selectedProfile?.strike) {
            return selectedProfile.strike
        }
        const storage = localStorage.getItem('scoreStorage');
        if (!storage) return 1;

        const scores = JSON.parse(storage);
        if (!scores.length) return 1;

        const days = scores
            .map(item => {
                const [day, month, year] = item.date.split('.').map(Number);
                return new Date(year, month - 1, day).setHours(0, 0, 0, 0);
            })
            .sort((a, b) => a - b);

        let currentStreak = 1;

        for (let i = 1; i < days.length; i++) {
            const diffDays = (days[i] - days[i - 1]) / (1000 * 60 * 60 * 24);
            if (diffDays === 1) currentStreak++;
            else if (diffDays > 1) currentStreak = 1;
        }

        localStorage.setItem("streak", currentStreak)
        return currentStreak;
    }
    const countStrike = getContinuousDays();

    return (
        <div
            className={`w-full h-screen overflow-hidden ${pathname === '/about'
                ? 'bg-[linear-gradient(180deg,_#F9F4E1_0%,_#FCF9EE_35.87%)]'
                : "sm:bg-[url('/backGrounds/newbackground.svg') bg-[url('/backGrounds/newbackgroundMobile.svg')]"
                }`}
        >
            <div className="flex h-full">

                {/* Left sidebar */}
                <LeftBar onClick={handleLeftBarClick} />

                {/* Right side */}
                <div ref={containerRef}
                    className="relative flex flex-col flex-1 h-full overflow-hidden">

                    <Navbar
                        onClick={handleNavBarClick}
                        refresh={open}
                        subscription={subscription}
                        sound={sound}
                        backgroundMusic={backgroundMusic}
                        screenSize={screenSize}
                        rightAnswers={rightAnswers}
                        handleOpenAvatar={() => setOpenAvatar(!openAvatar)}
                        handleBackgroundMusic={() => {
                            setBackgroundMusic(!backgroundMusic);
                            localStorage.setItem("backgroundMusic", !backgroundMusic);
                        }}
                        handleSound={() => {
                            setSound(!sound);
                            localStorage.setItem("sound", !sound);
                        }}
                        handleOpen={() => setOpen(!open)}
                        topButtonRef={toggleRef}
                        handleStrike={() => setStrike(!strike)}
                        handleGift={() => setGift(!gift)}
                        days={days}
                        giftRef={giftRef}
                        countStrike={countStrike}
                    />

                    {/* Modals */}
                    {gift && <Gift onClose={() => setGift(false)} days={days} />}
                    {strike && <Strike
                        onClose={() => setStrike(false)}
                        countStrike={selectedProfile?.strike}
                        dailyScore={dailyScore}
                    />}
                    {open && (
                        <Settings
                            hint={hint}
                            backgroundMusic={backgroundMusic}
                            sound={sound}
                            handleSubscription={handleSubscription}
                            handleBackgroundMusic={() => {
                                setBackgroundMusic(!backgroundMusic);
                                localStorage.setItem("backgroundMusic", !backgroundMusic);
                            }}
                            handleSound={() => {
                                setSound(!sound);
                                localStorage.setItem("sound", !sound);
                            }}
                            handleLanguages={() => {
                                setLanguage(!language);
                            }}
                            handleOpen={(hintOn) => {
                                setOpen(!open);
                                setHint(hintOn);
                            }}
                            progressReportEnabled={progressReportEnabled}
                            questionHistoryEnabled={questionHistoryEnabled}
                            deviceToken={user?.userEmail}
                        />
                    )}

                    {openSubscription && (
                        <Subscription
                            handleSubscription={handleSubscription}
                            subscriptionType={subscriptionType}
                            screenSize={screenSize}
                        />
                    )}

                    {openAvatar && (
                        <Avatar
                            avatars={avatar}
                            subscription={subscription}
                            handleSubscription={handleSubscription}
                            handleAvatar={() => {
                                if (!isChanged) setOpenAvatar(false)

                            }
                            }
                            handleOpenAvatar={() => setOpenAvatar(!openAvatar)}
                            setIsChanged={setIsChanged}
                        />
                    )}



                    {showAnimatedGift && name && (
                        <div
                            className="absolute z-[60] cursor-pointer"
                            style={{
                                left: targetPos
                                    ? targetPos.x
                                    : `${giftStartPercent.x}%`,
                                top: targetPos
                                    ? targetPos.y
                                    : `${giftStartPercent.y}%`,
                                transform: `
                                    translate(-50%, -50%)
                                    ${targetPos ? screenSize.width >= 736 ? "scale(0.5)" : screenSize.width >= 440 ? "scale(1.3)" : "scale(0.95)" : "scale(1)"}
                                `,

                                transition: "all 2s ease-in-out",
                            }}
                            onClick={handleGiftClick}
                        >

                            <IconGift
                                className="w-6 h-6 md:w-10 md:h-10 xl:w-16 xl:h-16"
                                style={{
                                    animation: targetPos ? "none" : "giftPulse 1.2s infinite",
                                }}
                            />
                            <style>
                                {`
                              @keyframes giftPulse {
                                0%, 100% { transform: scale(1); }
                                50% { transform: scale(1.3); }
                              }
                            `}
                            </style>
                        </div>
                    )}


                    {/* PAGE CONTENT */}
                    <div className="flex-1 overflow-y-auto">
                        <Outlet context={{
                            leftBarClicked,
                            navBarClicked,
                            handleAnimatedGiftClick,
                            days,
                            selectedProfile,
                            setDays,
                            progressReportEnabled,
                            questionHistoryEnabled,
                            openSubscription,
                            setOpenSubscription,
                            dailyScore,
                            handleSubscription
                        }} />


                    </div>

                    {/* Butttom icons */}
                    {location.pathname.startsWith('/games') && (<> <div className="flex gap-3 p-2 sm:hidden mt-[-90px] mb-[20px]">

                        {/* FIRE */}
                        <div className="relative z-20">
                            <button
                                onClick={() => setStrike(!strike)}
                                className="
                                w-[42px] h-[42px]
                                xs:w-[54px] xs:h-[54px]
                                rounded-full
                                border-[3px] border-[#4C957E]
                                bg-white
                                shadow-md
                                flex items-center justify-center
                                -translate-y-1/4
                                cursor-pointer
                                z-20
                            "
                            >
                                <IconFire className="w-[18px] xs:w-[28.35px] absolute right-[12px] top-[10px] xs:right-3 xs:top-3" />
                            </button>

                            <span
                                className="
                                absolute -top-1 right-2
                                bg-[#F15A29]
                                text-white
                                text-[8px] xs:text-[12px]
                                font-bold
                                rounded-full
                                w-[16px] h-[16px]
                                xs:w-[22px] xs:h-[22px]
                                flex items-center justify-center
                                z-30 border border-[#FCF9EE]
                            "
                            >
                                {countStrike}
                            </span>
                        </div>

                        {/* GIFT */}
                        <div ref={giftRefMobile} className="relative z-20">
                            <button
                                onClick={() => setGift(!gift)}
                                className="
                                w-[42px] h-[42px]
                                xs:w-[54px] xs:h-[54px]
                                rounded-full
                                border-[3px] border-[#4C957E]
                                bg-white
                                shadow-md
                                flex items-center justify-center
                                -translate-y-1/4
                                cursor-pointer
                                z-20
                            "
                            >
                                <IconGift className="w-[21.21px] xs:w-[30.27px] absolute right-[12px] top-[10px] xs:right-3 xs:top-3" />
                            </button>

                            <span
                                className="
                                absolute -top-1 right-2
                                bg-[#F15A29]
                                text-white
                                text-[8px] xs:text-[12px]
                                font-bold
                                rounded-full
                                w-[16px] h-[16px]
                                xs:w-[22px] xs:h-[22px]
                                flex items-center justify-center
                                z-30 border border-[#FCF9EE]
                            "
                            >
                                {days}
                            </span>
                        </div>

                        {/* TOP */}
                        <button
                            className="
                            w-[42px] h-[42px]
                            xs:w-[54px] xs:h-[54px]
                            rounded-full
                            border-[3px] border-[#4C957E]
                            bg-white
                            shadow-md
                            flex items-center justify-center
                            -translate-y-1/4
                            cursor-pointer
                            z-20
                        "
                        >
                            <IconTop className="w-[24px] xs:w-[34.29px]" onClick={() =>
                                navigate(
                                    location.pathname === leaderboardPath
                                        ? gamePath
                                        : leaderboardPath
                                )
                            } />
                        </button>

                    </div></>)}


                </div>
            </div>
        </div>
    );

}

